import React from 'react';
import { compose, is } from 'ramda';
import storage from '@synergycms_core/utils/storage';
import moment from 'moment';
import styleFile from './AmazonPayButton.js';
import { connect } from 'react-redux';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { List, Map } from 'immutable';
import { Button, Image } from '@synergycms_core/components/generic/';
import { withForm } from '@synergycms_core/components/generic/Form';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import AmazonPay from './AmazonPay';

const AmazonPayButton = class AmazonPayButton extends AmazonPay {
  static displayName = 'AmazonPayButton';

  /** @type {string} */
  amazonPayContainerID = 'AmazonPayButton';
  /** @type {string} */
  fullLangCode = '';
  /** @type {string} */
  redirectUrl = '';
  /** @type {boolean} */
  buttonRendered = false;
  /** @type {string|boolean} */
  validAccessToken = false;

  constructor(props) {
    super(props);
    const { langCode } = this.props.config;

    switch(langCode) {
      case 'es':
        this.fullLangCode = 'es-ES';
        break;
      case 'fr':
        this.fullLangCode = 'fr-FR';
        break;
      case 'it':
        this.fullLangCode = 'it-IT';
        break;
      case 'de':
        this.fullLangCode = 'de-DE';
        break;
      default:
        this.fullLangCode = 'en-GB';
        break;
    }

    this.checkExpiration();
  }

  onAmazonPaymentsReady = amazonPayMerchantID => () => {
    const { deviceType } = this.props.theme;
    const urlParts = window.location.href.split('#');
    const hashParts = urlParts[1].split('/');
    const [step, currency, trackingId] = hashParts;
    this.redirectUrl = urlParts[0] + '&step=' + step + '&currency=' + currency + '&tracking_id=' + trackingId;
    // TODO REMOVE NEXT LINE
    this.redirectUrl = window.location.href+'/';

    // render the button here
    let loginOptions;

    window.OffAmazonPayments.Button(this.amazonPayContainerID, amazonPayMerchantID, {
      type: 'PwA',
      color: 'Gold',
      size: deviceType === 'DESK' ? 'medium' : 'large',
      language: this.fullLangCode,

      authorization: () =>  {
        loginOptions = {scope: 'profile payments:widget', popup: true};
        window.amazon.Login.authorize(loginOptions, this.redirectUrl);
      }
    });
    this.buttonRendered = true;
  };

  loadButton = () => {
    const { amazonPayMerchantID, amazonPayClientID } = this.props.config;

    const onLoadFunc = () => {
      setTimeout(() => {
        const container = document.getElementById(this.amazonPayContainerID);
        if(container) {
          container.innerHTML = '';
          if (this.amazonPayScriptTag) {
            document.head.removeChild(this.amazonPayScriptTag);
            this.amazonPayScriptTag = null;
          }
          new Promise((resolve, reject) => {
            window.onAmazonLoginReady = this.onAmazonLoginReady(amazonPayClientID);
            window.onAmazonPaymentsReady = this.onAmazonPaymentsReady(amazonPayMerchantID);

            this.amazonPayScriptTag = this.addAmazonPayScriptTag();

            const onErrorFunc = () => {
              setTimeout(() => {
                this.amazonPayScriptTag = this.addAmazonPayScriptTag();
                this.amazonPayScriptTag.onerror = onErrorFunc;
                this.amazonPayScriptTag.onload = onLoadFunc;
              }, 1000);
            };

            const onLoadFunc = () => {
              resolve('ok');
            };

            this.amazonPayScriptTag.onerror = onErrorFunc;
            this.amazonPayScriptTag.onload = onLoadFunc;
          });

        } else {
          onLoadFunc();
        }
      }, 200);
    };
    onLoadFunc();
  };

  checkExpiration = () => {
    const timer = () => {
      setTimeout(() => {
        const amazonAccessToken = storage.getLocal('amazon_access_token');
        const amazonAccessTokenExpires = storage.getLocal('amazon_access_token_expire');
        if(amazonAccessToken && amazonAccessTokenExpires && moment().isBefore(moment(amazonAccessTokenExpires))) {
          this.validAccessToken = amazonAccessToken;
        } else {
          this.validAccessToken = false;
        }
        if((!this.validAccessToken && !this.buttonRendered) || (this.validAccessToken && this.buttonRendered)) {
          this.forceUpdate();
        }
        timer();
        /* TODO Quan funcioni el tema de URLs posar el moment exacte en que s'ha de comprovar */
      }, 5000 );
    };
    timer();
  };

  componentDidUpdate(prevProps) {

    if(!this.validAccessToken && !this.buttonRendered) {
      this.loadButton();
    } else if(this.validAccessToken && this.buttonRendered) {
      this.buttonRendered = false;
    }
  }

  render() {
    const { amazonPayEnabled, payFormSelected, validForm, onGlobalSubmit, langCode } = this.props.config;
    const { deviceType } = this.props.theme;
    const { classes } = this.props.theme.styles;
    let langImage;
    switch(langCode) {
      case 'es':
        langImage = 'es';
        break;
      case 'fr':
        langImage = 'fr';
        break;
      case 'it':
        langImage = 'it';
        break;
      case 'de':
        langImage = 'de';
        break;
      default:
        langImage = 'en';
        break;
    }
    const sizeImage = deviceType === 'DESK' ? '' : '_large';

    const amazonAccessToken = storage.getLocal('amazon_access_token');
    const amazonAccessTokenExpires = storage.getLocal('amazon_access_token_expire');
    if(amazonAccessToken && amazonAccessTokenExpires && moment().isBefore(moment(amazonAccessTokenExpires))) {
      this.validAccessToken = amazonAccessToken;
    } else {
      this.validAccessToken = false;
    }


    if(amazonPayEnabled && !this.validAccessToken) {
      return (
        <div className={payFormSelected === this.amazonPayForm ? '' : classes.displayNone}>
          <div id={this.amazonPayContainerID} className={validForm ? '' : classes.displayNone}/>
          <Button onClick={onGlobalSubmit} innerStyle={validForm ? classes.displayNone : ''} ariaLabel={'amazonPay'}>
            <Image src={'/assets/images/amazon_disabled_' + langImage + sizeImage + '.png'}/>
          </Button>
        </div>
      );
    } else if(amazonPayEnabled && this.validAccessToken && payFormSelected === this.amazonPayForm) {
      return (<ButtonSubmit
        richText={{
          text: '_%confirmar reserva%_',
          translate: true,
          ucFirst: true,
          innerStyle: ['toggleSecondButton'],
          rightIcon: {
            unicodeContent: langCode === 'AR' ? '005C' : 'e000',
            innerStyle: ['size12', 'absoluteButton']
          }
        }}
        innerStyle={['toggleSecondButton']}
      />);
    } else {
      return false;
    }
  }
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
  const amazonPayEnabled = hotel.getIn(['amazon_pay', 'name'], false);
  const amazonPayParams = amazonPayEnabled && hotel && hotel.getIn(['amazon_pay', 'tpv_params'], List());
  const amazonPayClientID = amazonPayParams.find(p => p.get('code') === 'client_id', Map()).get('value', '');
  const amazonPayMerchantID = amazonPayParams.find(p => p.get('code') === 'merchant_id', Map()).get('value', '');

  return {
    amazonPayEnabled: amazonPayEnabled,
    amazonPayClientID: amazonPayClientID,
    amazonPayMerchantID : amazonPayMerchantID,
    validForm: ownProps.form.validForm,
    onGlobalSubmit : ownProps.form.onGlobalSubmit
  };
};

export default compose(
  withForm(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'amazonPayEnabled',
    'amazonPayMerchantID',
    'amazonPayClientID',
    'payFormSelected',
    'langCode',
    'onSubmit',
    'validForm',
    'onGlobalSubmit',
    'amazonAccessToken',
    'amazonAccessTokenExpires'
  ]),
  withThemeJSS({ styleFile })
)(AmazonPayButton);
